
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"reportPerson"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportPerson"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"personType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"personKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"civilStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousCivilStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousCivilStatusDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"provinceOfResidenceForTaxYear"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"province"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postalCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"livesAlone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasPartner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfChildren"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCanadianCitizen"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonCanadianSituation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonCanadianArrivalDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonCanadianIncomeOutsideCanada"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonCanadianFirstReport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additionalName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approximateIncome"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasSameAddress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"livesOutsideCanada"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasTaxReport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isFullTimePostSecondaryStudent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated_at"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":633}};
    doc.loc.source = {"body":"fragment reportPerson on ReportPerson {\n  id\n  personType\n  personKey\n  lastName\n  firstName\n  gender\n  dateOfBirth\n  email\n  civilStatus\n  previousCivilStatus\n  previousCivilStatusDate\n  provinceOfResidenceForTaxYear\n  address {\n    id\n    address1\n    address2\n    city\n    province\n    postalCode\n    phone\n  }\n  livesAlone\n  hasPartner\n  numberOfChildren\n  isCanadianCitizen\n  nonCanadianSituation\n  nonCanadianArrivalDate\n  nonCanadianIncomeOutsideCanada\n  nonCanadianFirstReport\n  additionalName\n  approximateIncome\n  parents\n  hasSameAddress\n  livesOutsideCanada\n  hasTaxReport\n  isFullTimePostSecondaryStudent\n  updated_at\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["reportPerson"] = oneQuery(doc, "reportPerson");
        
